import Component from '../abstracts/Component';
import "simplebar/dist/simplebar.min.css";

export default class SimpleBarComponent extends Component {

  get SELECTORS() {
    return {
      main: '[data-simplebar-component="true"]'
    };
  }

  constructor() {
    super();
  }

  bindEvents() {
    this.$on(
      this.$customEvents.LOAD_COMPONENT.simplebar,
      this.importLibrary,
      window,
      null,
      this
    );
  }

  initSimpleBar(SimpleBar) {
    let barElements = document.querySelectorAll(this.SELECTORS.main);
    for (let el of barElements) {
      new SimpleBar(el);
    }
  }

  importLibrary(e) {
    let ctx = this;
    if (e) {
      ctx = e.event.data;
    }
    ctx.moduleLoader.loadSimpleBarAndExecute(
      module => {
        ctx.initSimpleBar(module.default);
      },
      error => {
        console.log('failed to load SimpleBar ', error.stack);
      }
    );
  }

  render() {
    this.log('Rendering...');
    if (document.querySelectorAll(this.SELECTORS.main)) this.importLibrary();
    this.bindEvents();
  }
}
